import React from 'react';

export default function ValidationMark({isValid}) {

    const label = isValid ? 'Tick' : 'Cross';
    const markStyles = {
        color: isValid ? 'green' : 'red'
    } ;
    return <span
        role="img"
        aria-label={label}
        style={markStyles}
    >
        {isValid ? '✅' : '❌'}
    </span>
}